/**
 * Zentrale Mapping-Helfer fuer numerische Schwellwerte → Farb-Klassen.
 *
 * Vor diesen Helfern haben Pages lokale Funktionen wie `getScoreColor`,
 * `docColor` oder `confColor` implementiert. Gleiche UX-Bedeutung (gut /
 * mittel / schlecht) sollte konsistent aussehen — deshalb leben die
 * Schwellwerte jetzt an einer Stelle.
 *
 * Die Funktionen geben Tailwind-Klassenstrings zurueck, damit sie sowohl auf
 * Pill-Spans als auch auf Badge-Varianten angewendet werden koennen.
 */

/**
 * ICP-/Lead-Score in eine Pill-Klassenkombination (Text + Hintergrund).
 * Thresholds: ≥80 gruen, ≥60 blau, ≥40 amber, sonst neutral.
 */
export function scoreToneClasses(score: number): string {
  if (score >= 80) return 'text-green-600 bg-green-50'
  if (score >= 60) return 'text-blue-600 bg-blue-50'
  if (score >= 40) return 'text-amber-600 bg-amber-50'
  return 'text-gray-600 bg-gray-50'
}

/**
 * Verhaeltnis-Wert (0..1) in eine reine Text-Farb-Klasse — fuer Inline-Kennzahlen
 * auf dunklem Hintergrund (z. B. Dashboard-Widget).
 * Thresholds: ≥0.8 gruen, ≥0.6 gelb, sonst rot.
 */
export function ratioToneClass(ratio: number): string {
  if (ratio >= 0.8) return 'text-green-400'
  if (ratio >= 0.6) return 'text-yellow-400'
  return 'text-red-400'
}

/**
 * KI-Konfidenzwert (0..100) in eine Pill-Klassenkombination (Text + Hintergrund).
 * Thresholds: ≥80 gruen, ≥50 gelb, sonst rot.
 */
export function confidenceToneClasses(confidence: number): string {
  if (confidence >= 80) return 'text-green-700 bg-green-50'
  if (confidence >= 50) return 'text-yellow-700 bg-yellow-50'
  return 'text-red-700 bg-red-50'
}
